<template>
  <div class="flex space-x-2">
      <div @click="toggleBold" :disabled="!isFocused" :class="[
        boldStyles,
        'w-6 h-6 rounded-md bg-[#F4F4F4]',
        'cursor-pointer flex items-center justify-center select-none',
      ]" >
      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2448_34472)">
          <path d="M12.9999 8.99159C13.8083 8.43325 14.3749 7.51659 14.3749 6.66659C14.3749 4.78325 12.9166 3.33325 11.0416 3.33325H5.83325V14.9999H11.6999C13.4416 14.9999 14.7916 13.5833 14.7916 11.8416C14.7916 10.5749 14.0749 9.49159 12.9999 8.99159ZM8.33325 5.41659H10.8333C11.5249 5.41659 12.0833 5.97492 12.0833 6.66659C12.0833 7.35825 11.5249 7.91659 10.8333 7.91659H8.33325V5.41659ZM11.2499 12.9166H8.33325V10.4166H11.2499C11.9416 10.4166 12.4999 10.9749 12.4999 11.6666C12.4999 12.3583 11.9416 12.9166 11.2499 12.9166Z" :fill="fillColor('bold')" />
          </g>
          <defs>
          <clipPath id="clip0_2448_34472">
          <rect width="20" height="20" fill="white"/>
          </clipPath>
          </defs>
          </svg>
      </div>

      <div @click="toggleItalic" :disabled="!isFocused" :class="[
        italicStyles,
        'w-6 h-6 rounded-md bg-[#F4F4F4]',
        'cursor-pointer flex items-center justify-center select-none',
      ]" >
           <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2448_34474)">
              <path d="M8.33333 3.33325V5.83325H10.175L7.325 12.4999H5V14.9999H11.6667V12.4999H9.825L12.675 5.83325H15V3.33325H8.33333Z" :fill="fillColor('italic')"/>
              </g>
              <defs>
              <clipPath id="clip0_2448_34474">
              <rect width="20" height="20" fill="white"/>
              </clipPath>
              </defs>
          </svg>
      </div>

      <div @click="toggleUnderline" :disabled="!isFocused" :class="[
        underlineStyles,
        'w-6 h-6 rounded-md bg-[#F4F4F4]',
        'cursor-pointer flex items-center justify-center select-none',
      ]" >
          <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2448_34476)">
              <path d="M10.0001 14.1667C12.7584 14.1667 15.0001 11.925 15.0001 9.16667V2.5H12.9167V9.16667C12.9167 10.775 11.6084 12.0833 10.0001 12.0833C8.39175 12.0833 7.08341 10.775 7.08341 9.16667V2.5H5.00008V9.16667C5.00008 11.925 7.24175 14.1667 10.0001 14.1667ZM4.16675 15.8333V17.5H15.8334V15.8333H4.16675Z" :fill="fillColor('underline')"/>
              </g>
              <defs>
              <clipPath id="clip0_2448_34476">
              <rect width="20" height="20" fill="white"/>
              </clipPath>
              </defs>
          </svg>
      </div>
  </div>
</template>

<script setup>
import { useTiptapStore } from '../../store/tiptap.store'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const tiptap = useTiptapStore()
const { editor, isFocused } = storeToRefs(tiptap)

const fillColor = button => isFocused.value && editor.value.isActive(button) ? '#2A8176' : '#444C58'

const boldStyles = computed(() => ({
  'bg-[#E5F2EA]': isFocused.value && editor.value.isActive('bold')
}))

const italicStyles = computed(() => ({
  'bg-[#E5F2EA]': isFocused.value && editor.value.isActive('italic')
}))

const underlineStyles = computed(() => ({
  'bg-[#E5F2EA]': isFocused.value && editor.value.isActive('underline')
}))

const isSelectedText = () => {
  const currentSelectionIsEmpty = editor.value ? editor.value.view.state.selection.empty : true
  if(!currentSelectionIsEmpty) return true
  return false
}

const toggleBold = () => {
  isSelectedText() && (editor.value && editor.value.chain().focus().toggleBold().run())
}
const toggleItalic = () => {
  isSelectedText() && (editor.value && editor.value.chain().focus().toggleItalic().run())
}
const toggleUnderline = () => {
  isSelectedText() && (editor.value && editor.value.chain().focus().toggleUnderline().run())
}

</script>
